var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack2TopIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 383.43 383.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 191.72,
    y1: 0,
    x2: 191.72,
    y2: 383.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68c185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009efb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.83,0c9.98,0,19.96,0,29.94,0,5.05,.71,10.11,1.36,15.16,2.12,77.24,11.71,141.23,72.22,157.4,148.71,1.81,8.55,2.66,17.23,4.1,25.82v29.94c-.59,4.31-1.12,8.64-1.78,12.94-7.08,45.89-27.64,84.66-62.48,115.35-44.66,39.35-97.01,54.66-155.78,46.35-45.83-6.48-84.38-27.61-114.95-62.37C9.13,274.17-6.12,221.83,2.2,163.05c6.43-45.43,27.54-83.44,61.59-114.2C88.97,26.1,118.23,11.29,151.37,4.03c8.42-1.84,16.99-2.6,25.46-4.03Zm26.82,224.25c0-21.57,0-43.15,.02-64.72,0-1.18-.56-2.83,.72-3.42,1.36-.63,2.11,.99,2.94,1.81,9.2,9.14,18.35,18.33,27.54,27.48,1.32,1.31,2.67,2.66,4.21,3.69,7.29,4.87,17.18,.33,18.17-8.34,.51-4.44-1.53-7.89-4.6-10.95-16.96-16.9-33.86-33.86-50.81-50.77-6.96-6.94-13.09-6.95-20.03-.02-16.86,16.83-33.69,33.68-50.52,50.53-.97,.97-1.95,1.95-2.74,3.06-4.38,6.22-2.07,15.02,4.83,17.56,5.24,1.93,9.99,.72,14.03-3.36,9.3-9.39,18.67-18.72,28.06-28.02,1.09-1.08,2.08-3.28,3.69-2.61,1.58,.65,.79,2.91,.79,4.45,.04,41.52,.03,83.05,.04,124.57,0,2.36-.11,4.73,.54,7.06,1.22,4.34,4.02,7.23,8.31,8.3,4.39,1.1,8.39,.08,11.61-3.38,2.77-2.98,3.23-6.61,3.23-10.43-.02-20.82,0-41.65,0-62.47Zm-12.02-118.73v.02c14.58,0,29.17,0,43.75,0,3.74,0,7.49,.1,11.21-.1,5.56-.3,9.9-4.56,10.72-10.24,.71-4.89-2.66-10.34-7.47-12.17-2.16-.82-4.42-.69-6.65-.69-34.28,0-68.55,0-102.83,0-1.25,0-2.5-.03-3.74,.1-4.81,.53-8.09,3.17-9.68,7.66-2.73,7.7,2.74,15.32,11.22,15.38,17.82,.13,35.65,.04,53.47,.04Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2TopIcn);
export default __webpack_public_path__ + "static/media/back_2_top_icn.8a8a860d245d89f41a08b09256f252a5.svg";
export { ForwardRef as ReactComponent };